<script setup lang="ts">
    import { CONTACT_TYPE, type ContactType } from '~/app/contact/enums/ContactType';

    defineProps<{
        contactType: ContactType;
        size?: 'sm' | 'md';
    }>();
</script>

<template>
    <span
        class="px-2 py-1 rounded-md uppercase font-semibold"
        :class="[contactType === CONTACT_TYPE.CLIENT ? 'bg-contact-client-bg text-contact-client-text' : 'bg-contact-supplier-bg text-contact-supplier-text', size === 'sm' ? 'text-xs' : 'text-sm']"
    >
        {{ $t(`contact.contactType.${contactType}`) }}
    </span>
</template>
